import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import IndustryNav from '../../components/IndustryNav';
import IndustrySidebar from '../../components/IndustrySidebar';
import icon from '../../images/icon/magic.svg';
import Seo from '../../components/Seo';

const IndustryAI = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    const solutions = [
        'AI-powered analytics',
        'Natural language processing',
        'Predictive modeling',
        'Intelligent automation',
        'Computer vision systems',
        'AI chatbots & assistants'
    ];

    const caseStudies = [
        { name: 'LawLab AI', link: 'lawlab_ai' },
        { name: 'Baraka AI', link: 'baraka_ai' }
    ];

    return (
        <Fragment>
            <Seo title="AI Solutions | OrbitroniX" description="Cutting-edge artificial intelligence and machine learning solutions." keywords="artificial intelligence, machine learning, AI solutions" url={`/${lang}/industries/ai`} />
            <Layout>
                <IndustryNav currentSlug="ai" lang={lang} />
                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="page-title pt-150 pos-rel bg_img">
                    <div className="container">
                        <div className="page-title-wrap sd-title-wrap">
                            <div className="row mt-none-30 align-items-end">
                                <div className="col-lg-9 mt-30">
                                    <motion.div initial={{ opacity: 0, x: -50 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.3 }} className="page-title-box">
                                        <motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }} className="sub-title">
                                            <img src={icon} alt="" /> {t('footer.industries') || 'Industries'}
                                        </motion.span>
                                        <motion.h2 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }} className="title">
                                            {t('industries.ai')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                <motion.section initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.8 }} className="terms&conditions-section pb-85 cp-det-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="item-details-widget" style={{ padding: '50px' }}>
                                    <p className="text-white-50 mb-4" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                                        Cutting-edge artificial intelligence and machine learning solutions. We build intelligent systems that automate, predict, and enhance business operations.
                                    </p>
                                    <h3 className="text-white mb-30">{t('common.solutionsWeOffer')}</h3>
                                    <div className="row mb-50">
                                        {solutions.map((solution, index) => (
                                            <div className="col-md-6 mb-3" key={index}>
                                                <div className="d-flex align-items-center">
                                                    <i className="fas fa-check-circle text-primary me-2"></i>
                                                    <span className="text-white-50">{solution}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <IndustrySidebar caseStudies={caseStudies} />
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default IndustryAI;
